import React, { useEffect, useMemo, useState } from "react";
import { useUserState } from "../../../../context/UserContext";
import { programByModule } from "../../../voditelji/components/utils";
import "./IntrospekcijeTable.css";
import RenderTableData from "./RenderTableData";
import RenderTableHeader from "./RenderTableHeader";

function IntrospekcijeTable({ data, programId }) {
  const { role } = useUserState();
  const userId = role;
  const [modifiedData, setModifiedData] = useState([]);
  const programModules = useMemo(() => {
    return (
      programByModule.find((program) => program.id === programId)?.moduleIds ||
      []
    );
  }, [programId]);
  const missingModuleIds = useMemo(() => {
    const existingModuleIds = new Set();
    data?.forEach((item) => {
      item.polaznici.forEach((polaznik) => {
        polaznik.introspections.forEach((introspection) => {
          existingModuleIds.add(introspection.theoreticalModuleId);
        });
      });
    });

    return programModules.filter(
      (moduleId) => !existingModuleIds.has(moduleId)
    );
  }, [data, programModules]);

  useEffect(() => {
    const updatedData = data?.map((item) => {
      const updatedPolaznici = item.polaznici.map((polaznik) => {
        const introspectionsWithBlanks = [...polaznik.introspections];
        missingModuleIds.forEach((moduleId) => {
          introspectionsWithBlanks.push({
            introspectionId: null,
            theoreticalModuleId: moduleId,
            isWritten: false,
            isRead: false,
          });
        });
        introspectionsWithBlanks.sort(
          (a, b) => a.theoreticalModuleId - b.theoreticalModuleId
        );
        const totalIntrospections = introspectionsWithBlanks.slice(
          0,
          programModules.length
        );

        return { ...polaznik, introspections: totalIntrospections };
      });

      return { ...item, polaznici: updatedPolaznici };
    });

    setModifiedData((prevData) => {
      if (JSON.stringify(prevData) !== JSON.stringify(updatedData)) {
        return updatedData;
      }
      return prevData;
    });
  }, [data, missingModuleIds, programModules]);

  const baseColumnNames = Array.from(
    { length: programModules.length },
    (_, i) => `Introspekcija ${i + 1}`
  );
  const columnNames = ["Mentor/Polaznik", ...baseColumnNames];
  const columnNamesVoditelj = ["Polaznici", ...baseColumnNames];
  return (
    <div className="scrollContainer">
      <table className="table-introspekcije">
        <thead>
          <RenderTableHeader
            columnNames={
              userId === "Voditelj" ? columnNamesVoditelj : columnNames
            }
          />
        </thead>
        <tbody>
          <RenderTableData
            data={modifiedData}
            emptyTDNumber={columnNames.length}
          />
        </tbody>
      </table>
    </div>
  );
}

export default IntrospekcijeTable;
